import { render, staticRenderFns } from "./GlobalDialog.vue?vue&type=template&id=4546433a&scoped=true"
import script from "./GlobalDialog.vue?vue&type=script&lang=js"
export * from "./GlobalDialog.vue?vue&type=script&lang=js"
import style0 from "./GlobalDialog.vue?vue&type=style&index=0&id=4546433a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546433a",
  null
  
)

export default component.exports